import React, { useEffect, useState } from "react";
import { Modal, Table, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { formatDateByLocale } from "../../../utils/dateFormat";
import { gql, useLazyQuery } from "@apollo/client";

const GET_ENROLLED_USERS = gql`
  query getEnrolledUsers($challengeId: String!) {
    getEnrolledUsers(challengeId: $challengeId) {
      enrolledDate
      user {
        _id
        name
        profile_image
        lastLoginAt
      }
    }
  }
`;

export default function EnrolledUsersModal({ open, challenge, onCancel }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getEnrolledUsers, { data, loading: queryLoading }] =
    useLazyQuery(GET_ENROLLED_USERS);

  useEffect(() => {
    if (open && challenge?._id) {
      setLoading(true);
      getEnrolledUsers({
        variables: {
          challengeId: challenge._id,
        },
      });
    }
  }, [open, challenge?._id, getEnrolledUsers]);

  useEffect(() => {
    if (data?.getEnrolledUsers) {
      setList(data.getEnrolledUsers || []);
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (queryLoading !== undefined) {
      setLoading(queryLoading);
    }
  }, [queryLoading]);

  const columns = [
    {
      title: "User",
      dataIndex: "user.name",
      key: "user",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Avatar
            src={record.user.profile_image}
            icon={<UserOutlined />}
            style={{ backgroundColor: "#1890ff" }}
          />
          <div style={{ fontWeight: 500, fontSize: "14px" }}>
            {record.user.name}
          </div>
        </div>
      ),
    },
    {
      title: "Enrolled Date",
      dataIndex: "enrolledDate",
      key: "enrolledDate",
      render: (date) => formatDateByLocale(date),
    },
    {
      title: "Last active",
      key: "lastLoginAt",
      render: (_, record) => formatDateByLocale(record.user?.lastLoginAt),
    },
  ];

  return (
    <Modal
      title={challenge ? `Enrolled List - ${challenge.title}` : "Enrolled List"}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Table
        columns={columns}
        dataSource={list}
        rowKey={(record) => record._id}
        loading={loading}
        size="small"
        total={list.length}
      />
    </Modal>
  );
}
